<p>network-devices works!</p>
